import { Button, Checkbox, Col, ConfigProvider, DatePicker, Flex, Form, Image, Input, Radio, Row, Select, Space, Spin, TimePicker, Upload } from "antd";
import { useState } from 'react';
// import DocumentPicker from 'react-native-document-picker';
// import { TouchableOpacity } from 'react-native-gesture-handler';
// import DropdownSelect from 'react-native-input-select';
// import {
//   Camera,
//   useCameraDevices
// } from 'react-native-vision-camera';
// import { useSelector } from 'react-redux';
// import MyPressable from '../../components/MyPressable';
// import I18n from '../../i18n';
// import Service from '../../service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import locale from 'antd/locale/fr_FR';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ReactCountryFlagsSelect from 'react-country-flags-select';
import idimage from '../assets/idimage.png';
import idphoto from '../assets/idphoto.png';
import pdf from '../assets/pdf.png';
import { Constant } from "../constant";
import './styles.css';

import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import 'dayjs/locale/fr';
import PhoneInput from "react-phone-input-2";

dayjs.locale('fr');
const { RangePicker } = DatePicker;
dayjs.extend(customParseFormat);
const dateFormat = 'DD/MM/YYYY';


const CustomNumeroEtudiantInput = ({props, element}) => {
  const [otp, setOtp] = useState(["","-" , "", "-", ""]);
  const handleChangeText = (text, index, element) => {
    const newOtp = [...otp];
    newOtp[index] = text;
    setOtp(newOtp);
    if(newOtp[0].length > 0 && newOtp[2].length > 0 && newOtp[4].length > 0 ) {
      let numero = newOtp[0] + newOtp[1] + newOtp[2] + newOtp[3] + newOtp[4]
      props.form.setFieldValue(element.name, numero);
    } else {
      props.form.setFieldValue(element.name, null);
    }
  };
  return (
    <div style={styles.container2}>
              {otp.map((digit, index) => (
                <Input
                  key={index}
                  style={
                    {
                      width: (index===0 || index===2 || index === 4) ? 105 :  34,
                      borderLeftWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: (index===0 || index===2 || index === 4) ? 1 : 0,
                      borderTopWidth: (index===0 || index===2 || index === 4) ? 1 : 0,
                      // backgroundColor: "red",
                      paddingHorizontal: (index===1 || index === 3) ? 2 : 0,
                      borderColor: '#000',
                      fontSize: 20,
                      textAlign: 'center',
                      // paddingHorizontal: 10,
                      paddingVertical: 5,
                      borderRadius: 10,
                      // width: 40,
                      height: 40,
                    }
                  }
                  maxLength={6}
                  value={digit}
                  disabled={(index === 1 || index === 3) ? true : false}
                  onChange={(text) => handleChangeText(text.target.value, index, element)}
                />
              ))}
            </div>
  );
}

let initValDate = [];
let initValheure = [];
let initValPicker = [];
const BaliseChamp = (props) => {
  const [photoPath, setPhotoPath] = useState("");
  const [verifEncour, setVerifEncour] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [spinner, setSpinner] = useState({
    pdf: {},
    photo: false
  })
  const [verificationReponse, setVerificationReponse] = useState({
    nomPdf: {},
    nomPhoto: {},
    pdf: {},
    photo: {},
  })
  let initVal = {};
  initVal = props.formState.initialValues;
  const [state, setState] = useState({
    dateValues: {},
    heureValues: {},
    pickerValues: {}
  })

  const verificationPdf = async (element, pickedFile) => {
    let spin = spinner;
    let verif = verificationReponse;
    spin[element.name] = true
    setVerifEncour(false)
    spin[element.name] = false
    verif.pdf[element.name] = 200
    verif.nomPdf[element.name] = pickedFile.name
    setSpinner({...spinner, pdf: spin})
    setVerificationReponse(verif)
    
    props.form.setFieldValue(element.name, pickedFile);
    // setVerifEncour(true)
    // // Pour choisir le pdf
    //   let spin = spinner;
    //   let verif = verificationReponse;
    //   spin[element.name] = true
    //     setSpinner({...spinner, pdf: spin})
    //       let formData = new FormData();
    //       formData.append("file", pickedFile);
    //       formData.append("type", element.name);
    //       Service.post("/ocr/pdf", "", formData, false).then(
    //         reponse => {
    //           setVerifEncour(false)
    //           spin[element.name] = false
    //           verif.pdf[element.name] = reponse.status
    //           verif.nomPdf[element.name] = pickedFile.name
    //           setSpinner({...spinner, pdf: spin})
    //           setVerificationReponse(verif)
    //           if(reponse.status === 200){
    //             props.form.setFieldValue(element.name, pickedFile);
    //           }
    //         },
    //         error => {
    //           setVerifEncour(false)
    //           verif.pdf[element.name] = error.status
    //           verif.nomPdf[element.name] = pickedFile.name
    //           setVerificationReponse(verif)
    //           spin[element.name] = false
    //           setSpinner({...spinner, pdf: spin})
    //         }
    //       )
  };

  const verifcationPhoto = (element, pickedFile) => {
    let spin = spinner;
    let verif = verificationReponse;
    spin[element.name] = true
    setVerifEncour(false)
    setPhotoPath(pickedFile);
    spin[element.name] = false
    verif.photo[element.name] = 200
    verif.nomPhoto[element.name] = pickedFile.name
    setSpinner({...spinner, pdf: spin})
    setVerificationReponse(verif)
    props.form.setFieldValue(element.name, pickedFile);
    // setVerifEncour(true)
    // let spin = spinner;
    // let verif = verificationReponse;
    // spin[element.name] = true
    // setSpinner({...spinner, pdf: spin})
    // setSpinner({...spinner, photo: true})
    //     let formData = new FormData();
    //     formData.append("file", pickedFile);
    //     Service.post("/ocr/photo", "", formData, false).then(
    //       reponse => {
    //         setVerifEncour(false)
    //         setPhotoPath(pickedFile);
    //         spin[element.name] = false
    //         verif.photo[element.name] = reponse.status
    //         verif.nomPhoto[element.name] = pickedFile.name
    //         setSpinner({...spinner, pdf: spin})
    //         setVerificationReponse(verif)
    //         if(reponse.status === 200){
    //           props.form.setFieldValue(element.name, pickedFile);
    //         }
    //       },
    //       error => {
    //         setVerifEncour(false)
    //         spin[element.name] = false
    //         verif.photo[element.name] = error.status
    //         verif.nomPhoto[element.name] = pickedFile.name
    //         setSpinner({...spinner, pdf: spin})
    //         setVerificationReponse(verif)
    //         setSpinner({...spinner, photo: false})     
    //         HandleAlertMessage(error, AlertType.normal)       
    //       }
    //     )
  }

  const verifcationImage = (element, pickedFile) => {
    let spin = spinner;
    let verif = verificationReponse;
    spin[element.name] = true
    setVerifEncour(false)
    setPhotoPath(pickedFile);
    spin[element.name] = false
    verif.photo[element.name] = 200
    verif.nomPhoto[element.name] = pickedFile.name
    setSpinner({...spinner, pdf: spin})
    setVerificationReponse(verif)
    props.form.setFieldValue(element.name, pickedFile);
  }

  const getPicker = (element, index) => {
    let pickerVal = state.pickerValues
    if(initVal !== undefined &&
      initVal[element.name] !== undefined &&
      !initValPicker.includes(initVal[element.name])
    ){
      pickerVal[element.name] = initVal[element.name]
      initValPicker.push(initVal[element.name])
    }
    let data = element.data.length > 0 ? element.data.filter(e=>e !== undefined) : []
    return <Select
              // defaultValue={state.pickerValues[element.name]}
              showSearch
              optionFilterProp="label"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%" }}
              options={data}
              mode={element.mode}
              onChange={(value)=> returnValue(value, element)}
            />
  }

  const getTimePicker = (element, index) => {
    let heureVal = state.heureValues
    if(initVal !== undefined &&
      initVal[element.name] !== undefined &&
      !initValheure.includes(initVal[element.name])
    ){
      heureVal[element.name] = initVal[element.name]
      initValheure.push(initVal[element.name])
    }
    return <ConfigProvider locale={locale}>
              <TimePicker
                key={"timepicker"+index}
                format={element.format}
                size={element.size}
                value={state.heureValues[element.name] !== undefined ? dayjs(state.heureValues[element.name], "HH:mm") : undefined}
                onChange={(date, dateString)=> onChangeData(date, element.typeChamps, element)} // Callback for when a date is selected
                style={{backgroundColor: 'transparent', width: "100%"}}
              />
          </ConfigProvider>
  }

  const getRangePicker = (element, index) => {
    return <>
      <ConfigProvider locale={locale}>
          <RangePicker
            key={"datepicker"+index}
            format={element.format}
            showTime={element.showTime}
            // defaultValue={[dayjs(element.minDate, element.format), dayjs(element.maxDate, element.format)]}
            onChange={(date, dateString)=> onChangeData(date, element.typeChamps, element)} // Callback for when a date is selected
            style={{backgroundColor: 'white', width: "100%" }}
          />
      </ConfigProvider>
      </>
  }

  const getDatePicker = (element, index) => {
    let dateVal = state.dateValues
    if(initVal !== undefined &&
      initVal[element.name] !== undefined &&
      !initValDate.includes(initVal[element.name])
    ){
      dateVal[element.name] = initVal[element.name]
      initValDate.push(initVal[element.name])
    }
    return <>
      <ConfigProvider locale={locale}>
          <DatePicker
            key={"datepicker"+index}
            format={element.format}
            value={state.dateValues[element.name] !== undefined ? dayjs(state.dateValues[element.name], "YYYY-MM-DD") : null}
            onChange={(date, dateString)=> onChangeData(date, element.typeChamps, element)} // Callback for when a date is selected
            minDate={dayjs(getFormattedDate(element.minDate), element.format)} // Optional: set minimum selectable date
            maxDate={dayjs(getFormattedDate(element.maxDate), element.format)} // Optional: set maximum selectable date
            style={{backgroundColor: 'white', width: "100%" }}
            picker={element.precision}
          />
      </ConfigProvider>
      </>
  }

  function getFormattedDate(today) {
    // Récupérer les parties de la date
    const day = String(today.getDate()).padStart(2, '0');  // Ajouter un 0 si nécessaire
    const month = String(today.getMonth() + 1).padStart(2, '0');  // Mois est de 0 à 11, donc on ajoute 1
    const year = today.getFullYear();
    
    // Retourner la date au format DD/MM/YYYY
    return `${day}/${month}/${year}`;
}

  const getPhoto = (element, index) => {
    if(initVal[element.name] !== undefined && initVal[element.name] !== null && initVal[element.name].trim() !== "" && photoPath === ""){
      setPhotoPath(initVal[element.name]);
    } else if(initVal[element.name] === undefined && typeof(photoPath) === "string" && photoPath.includes("http")) {
      setPhotoPath("");
    }
    return <Upload
              name="file"
              accept=".jpg,.jpeg,.png"
              onChange={(e) => verifcationPhoto(element, e.file.originFileObj)}
              fileList={fileList} // Contrôler la liste des fichiers via l'état
              showUploadList={false}
              disabled={verifEncour ? true : false}
            >
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <Image
                  preview={false}
                  style={element.styles}
                  src={photoPath === "" ? idphoto : ((typeof(photoPath) === "string") ? (photoPath.includes("http") ? photoPath : idphoto) : URL.createObjectURL(photoPath))}
                />
                {spinner.photo &&
                  <div style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                    <Spin size={element.spinnerSize} />
                    <p>{Constant.fr.verification}</p>
                  </div>
                }
                {(!spinner.photo[element.name] && verificationReponse.photo[element.name] !== undefined) &&
                  <div style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                    {verificationReponse.photo[element.name] === 200 
                    ?
                      <CheckCircleOutlined style={{color: 'green', fontSize: 20}}/>
                      :
                      <CloseCircleOutlined style={{color: 'red', fontSize: 20}}/>
                    }
                    <p>{verificationReponse.nomPhoto[element.name]}</p>
                  </div>
                }
              </div>
        </Upload>
  }

  const getImage = (element, index) => {
    if(initVal[element.name] !== undefined && initVal[element.name] !== null && initVal[element.name].trim() !== "" && photoPath === ""){
      setPhotoPath(initVal[element.name]);
    } else if(initVal[element.name] === undefined && typeof(photoPath) === "string" && photoPath.includes("http")) {
      setPhotoPath("");
    }
    return <Upload
              name="file"
              accept=".jpg,.jpeg,.png"
              onChange={(e) => verifcationImage(element, e.file.originFileObj)}
              fileList={fileList} // Contrôler la liste des fichiers via l'état
              showUploadList={false}
              disabled={verifEncour ? true : false}
            >
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <Image
                  preview={false}
                  style={element.styles}
                  src={photoPath === "" ? idimage : ((typeof(photoPath) === "string") ? (photoPath.includes("http") ? photoPath : idimage) : URL.createObjectURL(photoPath))}
                />
                {spinner.photo &&
                  <div style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                    <Spin size={element.spinnerSize} />
                    <p>{Constant.fr.verification}</p>
                  </div>
                }
                {(!spinner.photo[element.name] && verificationReponse.photo[element.name] !== undefined) &&
                  <div style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                    {verificationReponse.photo[element.name] === 200 
                    ?
                      <CheckCircleOutlined style={{color: 'green', fontSize: 20}}/>
                      :
                      <CloseCircleOutlined style={{color: 'red', fontSize: 20}}/>
                    }
                    <p>{verificationReponse.nomPhoto[element.name]}</p>
                  </div>
                }
              </div>
        </Upload>
  }

  const getContries = (element, index) => {
    if(initVal[element.name] !== undefined){
      setTimeout(() => {
        onChangeData(initVal[element.name], element.typeChamps, element)
      }, 500);
    }
    return <ReactCountryFlagsSelect
              selected={initVal[element.name] !== undefined ? initVal[element.name] : null}
              onSelect={(e)=> onChangeData(e, element.typeChamps, element)}
              fullWidth
              searchable
              searchPlaceholder={Constant.fr.choosePays}
              classes={{searchSelect: "container"}}
              selectedSize={15}
            />
  }
  const getPdf = (element, index) => {
    return <Upload
                name="file"
                accept=".pdf"
                onChange={(e) => verificationPdf(element, e.file.originFileObj)}
                fileList={fileList} // Contrôler la liste des fichiers via l'état
                showUploadList={false}
                disabled={verifEncour ? true : false}
              >
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <Image
                  preview={false}
                  style={element.styles}
                  src={pdf}
                />
                {spinner.pdf[element.name] &&
                  <div style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                    <Spin size={element.spinnerSize} />
                    <p>{Constant.fr.verification}</p>
                  </div>
                }
                {(!spinner.pdf[element.name] && verificationReponse.pdf[element.name] !== undefined) &&
                  <div style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                    {verificationReponse.pdf[element.name] === 200 
                    ?
                      <CheckCircleOutlined style={{color: 'green', fontSize: 20}}/>
                        :
                        <CloseCircleOutlined style={{color: 'red', fontSize: 20}}/>
                    }
                    <p>{verificationReponse.nomPdf[element.name]}</p>
                  </div>
                }
              </div>
             </Upload>
  }

  const getNumeroEtudiant = (element, index) => {
    return <CustomNumeroEtudiantInput props={props} element={element}/>
  }

  const getInput = (element, index) => {
    return <Input
              type={element.type}
              allowClear={element.allowClear}
              style={element.styles}
              styles={element.inputStyle}
              // defaultValue={element.defautValue}
              value={element.value}
              placeholder={element.placeholder}
              disabled={element.disabled}
              maxLength={element.maxLength}
              prefix={element.prefix}
              showCount={element.showCount}
            />
  }

  const getCKeditor = (element, index) => {
    return <CKEditor
              editor={ClassicEditor}
              data={initVal[element.name]}
              onChange={(event, editor) => {
                props.form.setFieldValue(element.name, editor.getData());
              }}
            />
  }

  const getInputsArea = (element, index) => {
    return <Input.TextArea
              allowClear={element.allowClear}
              style={element.styles}
              styles={element.inputStyle}
              // defaultValue={element.defautValue}
              value={element.value}
              placeholder={element.placeholder}
              disabled={element.disabled}
              maxLength={element.maxLength}
              autoSize={element.autoSize}
              showCount={element.showCount}
              rows={element.rows}
            />
  }

  const getOnPress = (element,) => {
    if(element.onPress === Constant.baliseData.onPress.validate) {
      props.onSubmit()
    } else if(element.onPress === Constant.baliseData.onPress.return) {
      props.return(element)
    }
  }

  const getCheckbox = (datas, index) => {
    return <Checkbox.Group style={{...datas.styles, display: 'flex', flexDirection: datas.rowBalise ? 'row' : "column" }} options={datas.options} onChange={(e)=> onChangeData(e, datas.typeChamps, datas)} />
  }
  const ButtonBalise = (element, index2) => {
    return <Button
              key={index2 + "j"}
              type={element.type}
              // disabled={element.disabled}
              disabled={element.disabled ? props.spinnerBouton : false}
              style={element.styles}
              size={element.size}
              onClick={(e)=>getOnPress(element)}
              icon= {element.icon}
              shape= {element.shape}
              variant={element.variant}
            >
              {element.text} {props.spinnerBouton && <Spin indicator={<LoadingOutlined spin style={{color: Constant.couleur.primary}}/>} />}
            </Button>
  }
  const getButtons = (datas, index) => {
            return <Flex justify={datas.spaceBetween ? "space-between" : "start"} align="flex-start" gap="small" vertical={datas.rowBalise ? false : true} wrap key={index + "bouton"}>
                        {datas.item.length > 0 && datas.item.map((element, index2)=> {
                            return ButtonBalise(element, index2)
                        })}
              </Flex>
            
  }
  const returnValue = (value, element) => {
    if(element.returnValue === true) {
      props.returnValue(element.name, value);
    }
  }
    
  const onChangeData = (e, typeChamp, element) => {
   // DatePicker
    if(typeChamp === Constant.baliseData.typeChamp.DatePicker) {
      let val = state.dateValues
      val[element.name] = e;
      setState({...state, dateValues: val})
      props.form.setFieldValue(element.name, e)
    }
    // RangePicker
    else if(typeChamp === Constant.baliseData.typeChamp.RangePicker) {
      // let val = {}
      // val[element.name] = e;
      // setState({...state, dateValues: val})
      props.form.setFieldValue(element.name, e)
    }
    //TimePicker
    else if(typeChamp === Constant.baliseData.typeChamp.TimePicker) {
      let val = state.heureValues
      val[element.name] = e;
      setState({...state, heureValues: val})
      props.form.setFieldValue(element.name, e)
    } else
    // Picker
    if(typeChamp === Constant.baliseData.typeChamp.Picker) {
      let val = {}
      val[element.name] = e;
      setState({...state, pickerValues: val})
      props.form.setFieldValue(element.name, e)
    }
    // Contries
    if(typeChamp === Constant.baliseData.typeChamp.Contries) {
      if(e !== null) {
        let d = {
          code: e.countryCode,
          name: e.label,
        }
        props.form.setFieldValue(element.name, JSON.stringify(d))
      } else {
        props.form.setFieldValue(element.name, null)
      }
    }
  }

  const getRadiosGroup = (element, index) => {
    let content = element.item !== undefined && element.item.map((element2, index2)=> {
        return getRadios(element2, index2)
      })
    return <Radio.Group
              key={index+"c"}
              defaultValue={element.defautValue}
              disabled={element.disabled}
              options={element.options}
              style={element.styles}
              onChange={(value)=> returnValue(value.target.value, element)}
              >
                <Space direction={element.rowBalise ? "horizontal" : "vertical"}>
                  {content}
                </Space>
            </Radio.Group>
  }

  const getRadios = (element, index) => {
    return <Radio
            key={index + "d"}
            value={element.value}
            defaultChecked={element.defaultChecked}
            checked={element.checked}
            disabled={element.disabled}
            style={element.styles}
          >
            {element.text}
          </Radio>
  }

  const getPhoneInput = (element, index) => {
    return <PhoneInput
            value={element.value}
            placeholder={element.placeholder}
            disabled={element.disabled}
            // onChange={setValue}
            style={element.styles}
            styles={element.inputStyle}
            country={"ml"}
            countryCodeEditable={false}
            inputStyle={{width: "100%"}}
          />
  }

  const getFormItem = (element, index) => {
    return <Form.Item
              key={index}
              label={element.label}
              name={element.name}
              rules={element.rules}
              hasFeedback
              labelCol={element.labelStyle}
              wrapperCol={element.formWrapperStyle}
              style={element.formItemStyles}
              help={element.helpMessage}
              layout={element.layout}
            >
                {(element.typeChamps === Constant.baliseData.typeChamp.CKeditor) &&
                  getCKeditor(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.InputsArea) &&
                  getInputsArea(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.NumeroEtudiant) &&
                  getNumeroEtudiant(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.Inputs) &&
                  getInput(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.DatePicker) &&
                  getDatePicker(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.Picker) &&
                  getPicker(element, index)
                }
                {(element.item !== undefined && element.item.length > 0 && element.item[0].typeChamps === Constant.baliseData.typeChamp.Buttons) &&
                  getButtons(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.Checkbox) &&
                  getCheckbox(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.RadiosGroup && element.item !== undefined) &&
                  getRadiosGroup(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.Image) &&
                  getImage(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.Photo) &&
                  getPhoto(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.Pdf) &&
                  getPdf(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.Contries) &&
                  getContries(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.Phone) &&
                  getPhoneInput(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.TimePicker) &&
                  getTimePicker(element, index)
                }
                {(element.typeChamps === Constant.baliseData.typeChamp.RangePicker) &&
                  getRangePicker(element, index)
                }
            </Form.Item>
  }

  const getEngagement = (element, index) => {
    return <>{(element.value !== undefined && element.value.length > 0) && element.value.map((elementValue, indexValue) => {
                    if(elementValue.typeChamps === Constant.baliseData.typeChamp.Text) {
                      return <p style={elementValue.labelStyle} key={indexValue+index+'engagement'}>{elementValue.text}</p>
                    } else {
                        return getFormItem(elementValue,  indexValue+index+'engagement')
                      }
                    })}
                </>
  }

  return (
    <Row gutter={[16, 16]}>
            {
              props.formState.champs.map((element, index)=> {
                if(element !== false){
                  return <Col
                            key={index+ "col"}
                            xs={element.xs}
                            sm={element.sm}
                            md={element.md}
                            lg={element.lg}
                            xl={element.xl}
                            xxl={element.xxl}
                          >
                            {(element.typeChamps === Constant.baliseData.typeChamp.Engagement)
                              ?
                                getEngagement(element, index+"e")
                              :
                                getFormItem(element, index+"a")
                            }
                          </Col>
                }
              })
            }
    </Row>
  );
};

const styles = {
  container2: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginHorizontal: 20,
  },
  input: {
    // borderBottomWidth: 2,
    borderColor: '#000',
    fontSize: 20,
    textAlign: 'center',
    // paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 10,
    // width: 40,
    height: 40,
  },
  faceBox: {
    position: 'absolute',
    borderWidth: 2,
    borderColor: 'red',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    marginHorizontal: 16,
    paddingTop: 8,
    width: 80,
    height: 80,
  },
  btn: {
    backgroundColor: '#63995f',
    margin: 5,
    height: 70,
    width: 70,
    padding: 5,
    borderRadius: 50,
    justifyContent: 'center'
  },
  btn2: {
    backgroundColor: '#5d0221',
    margin: 5,
    paddingHorizontal: 8,
    padding: 4,
    borderRadius: 8,
  },
  btnText: {
    color: '#ffffff',
    fontSize: 20,
    textAlign: 'center',
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: 'black',
  },
  prediv: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  capture: {
    flex: 0,
    backgroundColor: '#fff',
    borderRadius: 5,
    padding: 15,
    paddingHorizontal: 20,
    alignSelf: 'center',
    margin: 20,
  },
  headerContainer: {
    height: 52,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingBottom: 0,
  },
  headerText: {
    flex: 1,
    fontSize: 22,
    fontFamily: 'WorkSans-Bold',
    textAlign: 'center',
    textAlignVertical: 'center',
  },
};

export default BaliseChamp;
